export function logger(msg) {
  if(process.env.REACT_APP_DEBUG_LOGGER === "true") {
    console.log(msg);
  }
  return;
}